import { LoadTextures } from '../../../../vendors/ngab/load/LoadTextures';
import { FONTS } from '../../../constants/fonts';
import { convertArrayToObject } from '../../../utils/array';

const loadFont = require('load-bmfont');

const fontFileRegular = require('../../../../assets/fonts/CormorantGaramond-Regular.fnt').default;
const fontAtlasRegular = require('../../../../assets/fonts/CormorantGaramond-Regular.png').default;

const fontFileItalic = require('../../../../assets/fonts/CormorantGaramond-Italic.fnt').default;
const fontAtlasItalic = require('../../../../assets/fonts/CormorantGaramond-Italic.png').default;

const fonts = {
    map: new Map(),
    loaded: false
};

const loadFnt = (url) => new Promise((resolve, reject) => {
    loadFont(url, (err, font) => {
        if (font && !err) resolve(font);
        else reject(err);
    });
});

const loadFntArray = async (items) => {
    const result = {};
    let err = null;

    await Promise.all(items.map((item) => loadFnt(item.url).then((font) => {
        result[item.id || item.name] = font;
    }).catch(() => {
        err = `Font ${item.id || item.name} path ${item.url} failed`;
        console.warn(err);
    })));

    if (err) return { error: err, result };

    return result;
};

export const FontsStorage = {
    async loadBMFs(progressUpdate) {
        if (fonts.loaded) return fonts.map;

        const fontFiles = [
            {
                name: FONTS.REGULAR,
                url: fontFileRegular,
                fontSizeFix: 1
            },
            {
                name: FONTS.ITALIC,
                url: fontFileItalic,
                fontSizeFix: 120 / 70
            }
        ];
        const fontAtlases = [
            {
                name: FONTS.REGULAR,
                url: fontAtlasRegular
            },
            {
                name: FONTS.ITALIC,
                url: fontAtlasItalic
            }
        ];

        let atlases = null;
        let fnts = null;
        const fontFilesMap = convertArrayToObject(fontFiles, 'name');

        try {
            atlases = await LoadTextures(fontAtlases, true, true, progressUpdate, false);
        } catch (e) {
            console.warn('Atlas loading failed', e);
        }

        try {
            fnts = await loadFntArray(fontFiles);
        } catch (e) {
            console.warn('Fonts loading failed');
        }

        if (!fnts || fnts.error) throw new Error(fnts.error);

        const fontFamilies = Object.keys(fnts);

        fontFamilies.forEach((family) => {
            const font = fnts[family];
            const atlas = atlases[family];

            if (!font || !atlas) return;

            const { fontSizeFix } = fontFilesMap[family];

            fonts.map.set(family, {
                font,
                atlas: atlas.texture,
                fontSizeFix
            });
        });

        return fonts.map;
    },

    get(familyName) {
        if (fonts.map.has(familyName)) return fonts.map.get(familyName);

        return null;
    }
};
